import { handle400Statuses, sendApiRequest } from './api';
import { logNetRequest } from '@utils/usefulFuncs';
import { gptModelsActionTypes } from '@constants/actionTypes';
import { setGptModelCatalog } from '@constants/ai';

const URL = 'v2/genai/models';

function pickDefaultId(models) {
  if (!Array.isArray(models) || models.length === 0) {
    return null;
  }
  const defaultEntry = models.find((m) => m && m.is_default);
  if (defaultEntry) {
    return defaultEntry.id;
  }
  return models[0].id;
}

export async function fetchGptModels() {
  const { status, data, error } = await sendApiRequest('get', URL);
  logNetRequest(URL, status, data, error);
  handle400Statuses(status);

  if (status === 200 && Array.isArray(data?.models)) {
    const models = data.models;
    return {
      ok: true,
      status,
      models,
      defaultId: pickDefaultId(models),
      error: null,
    };
  }

  return {
    ok: false,
    status,
    models: [],
    defaultId: null,
    error: data?.error || error || 'Unable to load GPT models',
  };
}

export const loadGptModels = () => {
  return async (dispatch) => {
    dispatch({ type: gptModelsActionTypes.setLoading });

    const result = await fetchGptModels();

    if (result.ok) {
      const payload = { models: result.models, defaultId: result.defaultId };
      setGptModelCatalog(payload);
      dispatch({ type: gptModelsActionTypes.set, payload });
      return result;
    }

    setGptModelCatalog({ models: [], defaultId: null });
    dispatch({
      type: gptModelsActionTypes.setError,
      payload: { error: result.error, status: result.status },
    });
    return result;
  };
};
